<template>
    <page>
		<module enable-flex>
			<m-operate>
				<c-button power="b_product_type_add" color="sys" icon="add" @click="addHandle(null)">新增一级类目</c-button>
                <c-button color="black" icon="release" @click="releaseHandle()">发布</c-button>
            </m-operate>
			
			<c-table ref="table" :paging="false">
				<c-table-column
					type="expand"
					label="类目名称"
					name="type_name"
					add-button="添加子类目"
					expand-limit="3"
					width="300"
					@expand="loadChildren"
					@add="addHandle"
				>
				</c-table-column>

                <c-table-column
                    label="商品类型"
                    name="id"
                    width="70"
                    v-if="systemConfig.is_virtual_product == 'ON'"
                >
                    <template v-slot="{data}">
                        <span v-if="data.is_virtual==0">实物商品</span>
                        <span v-if="data.is_virtual==1" style="color: blue">虚拟商品</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="类目ID"
                        name="id"
                        width="70"
                ></c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					@sort="sortHandle"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="110"
				>
					<template v-slot="row">
						<c-table-button power="b_product_type_edit" @click="editHandle(row)">编辑</c-table-button>
						<c-table-button power="b_product_type_del" @click="deleteHandle(row)">删除</c-table-button>
						<c-table-button power="b_product_type_edit" @click="specConfig(row)">规格配置</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="dialog" :title="classifyEditTitle" width="600" height="300" @resolve="addChild">
			<c-form ref="classifyEdit">
				<c-form-item type="input" label="类目名称" name="type_name" required></c-form-item>
                <c-form-item type="radio" label="商品类型" v-if="systemConfig.is_virtual_product == 'ON' && editLevel==0"
                             v-model="isVirtual" name="is_virtual" :options="isVirtualOptions"
                             :word="isVirtualWord" :disabled="editState || editLevel > 0"></c-form-item>
			</c-form>
		</c-dialog>
		
		<c-dialog ref="specConfigDialog" title="配置规格" width="900" height="581" @resolve="specConfigHandle">
			<c-form ref="specConfig" :label-align="false">
				<c-form-item type="radio" label="是否允许对单个SKU图片进行修改" name="is_support_sku_img" :options="skuImageOptions"></c-form-item>
				<c-form-item :label="false">
					<div class="spec-list">
						<div v-for="(spec, i) in specList" :key="i" class="spec">
							<div class="flex">
								<label class="spec-label">规格名</label>
								<div>
									<div class="flex-center-cross">
										<input v-model="spec.name" class="spec-name" type="text" @change="specNameVerify(spec, i)">
										<c-checkbox :checked="spec.image" @change="specImageCheck($event, spec)">配图</c-checkbox>
									</div>
									<div class="spec-item-list flex-wrap">
										<div v-for="(item, j) in spec.itemList" :key="j" class="spec-item flex-center-cross">
											<input v-model="item.value" class="spec-item-value flex-grow" type="text" @change="specValueVerify(item, spec.itemList)">
											<a class="spec-item-remove tf tf-clear" @click="removeItem(spec, j)"></a>
										</div>
									</div>
									<c-button background="#4A528D" icon="add" @click="addSpecItem(spec)">添加规格值</c-button>
								</div>
								<div v-show="specList.length > 1" class="spec-handle flex">
									<a class="spec-handle-item" @click="sortSpec(i, 'up')"><i class="tf tf-sort-up"></i></a>
									<a class="spec-handle-item" @click="sortSpec(i, 'down')"><i class="tf tf-sort-down"></i></a>
									<a class="spec-handle-item" @click="removeSpec(i)"><i class="tf tf-trash"></i></a>
								</div>
							</div>
						</div>
						<c-button size="m" radius="2" @click="addSpec">新增规格项</c-button>
					</div>
				</c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		name: 'm_product_type',
		
		data() {
			return {
				editState: false,
                classifyEditTitle:'编辑类目',
				skuImageOptions: [{
					name: '是',
					value: 1
				}, {
					name: '否（建议）',
					value: 0
				}],
				specIndex: 0,
				specList: [],
                isVirtual:0,          //是否是虚拟商品 0=实物 1=虚拟
                isVirtualOptions: [
                    {name: '实物商品',value: 0},
                    {name: '虚拟商品',value: 1}
                ],
                editLevel:-1         //当前所属类目等级
			}
		},
        computed: {
            ...mapState(['systemConfig', 'userInfo']),

            isVirtualWord() {
                return {
                    0: '发布商品时，需要选择运费模板；下单时，需要填写收货地址、选物流公司',
                    1: '虚拟商品无需发货，无需配置运费模板',
                }[this.isVirtual]
            }
        },
		mounted() {
			this.$refs.table.load({
				url: '/product_type/list',
				data: {
					parent_id: 0
				}
			});
		},
		
		methods: {
			loadChildren(row, resolve) {
				this.request({
					url: '/product_type/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data || []);
					}
				});
			},
			
			addHandle(row, resolve) {
				this.editState = false;
                this.editLevel = row ? row.expandData.level + 1 : 0;
                this._edit = 0;
				this._parent = row ? row.data.id : 0;
				this._resolve = data => {
					row ? resolve(data) : this.$refs.table.push(data);
				};
				this.$refs.classifyEdit.clear();
                if (this.editLevel == 0){
                    this.classifyEditTitle = '添加一级类目';
                }else {
                    this.classifyEditTitle = '在【'+row.data.type_name+'】类目下添加子类目';
                }
                this.$refs.dialog.open();
			},
			
			editHandle(row) {
				this.editState = true;
                this.editLevel = row.expandData.level;
                this._edit = row.data.id;
				this._parent = row.expandData.parent ? row.expandData.parent.data.id : 0;
                this._resolve = data => {
					row.update(data[0]);
				};
                this.classifyEditTitle = '编辑类目【'+row.data.type_name+'】';
                this.$refs.classifyEdit.set(row.data);
				this.$refs.dialog.open();
			},
			
			deleteHandle(row) {
                this.$confirm({
                    text: '确定要删除当前商品类目【'+row.data.type_name+'】吗2？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product_type/remove',
                            data: {
                                id: row.data.id
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '删除成功'
                                });
                                row.remove();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
			},
			
			sortHandle(row, type, next) {
				this.request({
					url: '/product_type/sort',
					data: {
						id: row.data.id,
						parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
						type: ['top', 'bottom'].includes(type) ? type : '',
						id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
						id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
                        if (type == 'top' || type == 'bottom') {
                            this.$refs.table.update();
                        } else {
                            next();
                        }
					}
				});
			},
			
			addChild(stop) {
				stop();
				var data = this.$refs.classifyEdit.serialize();
				if (!data.type_name) {
					this.$message({
						text: '请填写类目名称'
					});
					return;
				}
				this.request({
					url: this._edit ? '/product_type/batch_edit' : '/product_type/add',
					data: this._edit ? {
						data_list: [Object.assign(data, {
							id: this._edit,
							parent_id: this._parent
						})]
					} : Object.assign(data, {
						parent_id: this._parent
					}),
					loading: true,
					success: data => {
						this.$message({
							text: this._edit ? '编辑成功' : '添加成功'
						});
						this.$refs.dialog.close();
						this._resolve(data);
					}
				});
			},
			
			specConfig(row) {
				this._specConfigId = row.data.id;
				this.request({
					url: '/product_type/specs',
					data: {
						product_type_id: row.data.id
					},
					loading: true,
					success: data => {
						this.$refs.specConfigDialog.open();

						data.is_support_sku_img = data.is_support_sku_img || 0;
						this.$refs.specConfig.set(data);
						this.specList = Array.from(data ? data.spec_list : [], spec => {
							return {
								name: spec.group_name,
								image: spec.group_img_flag == 2,
								itemList: Array.from(spec.children, item => {
									return {
										id: item.group_id,
										value: item.group_value
									}
								})
							}
						});
						if (!this.specList.length) {
							this.addSpec();
						}
					}
				});
			},
			
			specNameVerify(spec, index) {
				if (this.specList.find((item, i) => {
					return index != i && item.name == spec.name;
				})) {
					this.$message({
						text: '规格名不能重复，请重新输入'
					});
					spec.name = '';
				}
			},
			
			specImageCheck(state, spec) {
				if (state) {
					let crt = this.specList.find(item => item.image && item != spec);
					crt && (crt.image = false);
				}
				spec.image = state;
			},

			specConfigHandle(stop) {
				stop();
				
				this.$refs.specConfig.submit({
					url: '/product_type/save_specs',
					
					rule: {
						spec: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									if (!this.specList[i].name) {
										state = false;
										break;
									}
								}
								return state;
							},
							word: '请完善规格名'
						}],
						
						spec_value: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									for (let j in this.specList[i].itemList) {
										if (!this.specList[i].itemList[j].value) {
											state = false;
											break;
										}
									}
								}
								return state;
							},
							word: '请完善规格值'
						}]
					},
					
					dataFormatter: data => {
						let specList = [];
						this.specList.forEach((spec, i) => {
							(spec.itemList.length ? spec.itemList : [{}]).forEach((item, j) => {
								specList.push({
									product_type_id: this._specConfigId,
									group_name: spec.name,
									group_value: item.value,
									group_img_flag: spec.image ? 2 : 1,
									group_level: i+1,
									sort_id: j+1
								});
							});
						});
						
						data.product_type_id = this._specConfigId;
						data.spec_list = specList;
						
						return data;
					},
					
					success: data => {
						this.$message({
							text: '规格配置保存成功'
						});
						this.$refs.specConfigDialog.close();
					}
				});
			},
			
			addSpec() {
				if (this.specList.length == 3) {
					this.$message({
						text: '最多只能添加三个规格项'
					});
					return;
				}
				var item = {
					name: '',
					itemList: []
				};
				this.specList.push(item);
			},
			
			sortSpec(index, type) {
				if ((type == 'up' && index == 0) || (type == 'down' && index == this.specList.length - 1)) return;
				var spec = this.specList.splice(index, 1)[0];
				this.specList.splice(type == 'up' ? index - 1 : index + 1, 0, spec);
			},
			
			removeSpec(index) {
				this.specList.splice(index, 1);
			},
			
			addSpecItem(spec) {
				var id = `spec${this.specIndex++}`;
				
				spec.itemList.push({
					id,
					value: ''
				});
			},
			
			specValueVerify(spec, list) {
				if (list.find(item => {
					return item.id != spec.id && item.value == spec.value;
				})) {
					this.$message({
						text: '规格值不能重复，请重新输入'
					});
					spec.value = '';
				}
			},
			
			removeItem(spec, index) {
				spec.itemList.splice(index, 1);
			},

            //发布
            releaseHandle(row, resolve) {
                this.$confirm({
                    text: '确定要发布吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product_type/release',
                            data: {},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '发布成功',
                                    icon: 'success'  // 图标（success：成功，fail：失败）
                                });
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },
		}
	}
</script>

<style lang="stylus" scoped>
	.spec {
		position: relative;
		padding: 15px 17px;
		background: #F9F8FB;
		
		&:nth-child(n+2) {
			margin-top: 16px;
		}
		
		&-list {
			.c-button {
				margin-top: 16px;
			}
		}
		
		&-label {
			margin-right: 8px;
			line-height: 36px;
			font-size: 13px;
			white-space: nowrap;
			color: #444;
		}
		
		&-handle {
			position: absolute;
			right: 0;
			top: 0;
		
			&-item {
				width: 24px;
				margin-left: 5px;
				line-height: 24px;
				font-size: 12px;
				text-align: center;
				color: #fff;
				background: #aaa;
				
				&:hover {
					background: #999;
				}
			}
		}
		
		&-name {
			width: 130px;
			height: 34px;
			border: 1px solid #ddd;
			padding: 0 10px;
			margin-right: 14px;
			font-size: 13px;
			background: #fff;
		}
		
		&-item {
			width: 128px;
			height: 30px;
			border: 1px solid #ddd;
			padding: 0 5px;
			margin-top: 12px;
			margin-right: 12px;
			background: #fff;
			
			&-value {
				font-size: 13px;
			}
			
			&-remove {
				margin-left: 5px;
				font-size: 16px;
				color: #C70000;
			}
		}
		
		.c-button {
			margin-top: 16px;
		}
	}
</style>